<template>
<div>
  <div class="section-header">
    <h1>Client Onboarding</h1>
 </div>
  <div class="card card--white">
    <div class="card card--container">
    <form v-if="!csvUploadedUsers.length" class="row flex-wrap col-at-xs">
      <h-input
        label="First Name"
        v-model="first_name"
        type="text"
        required
      />
      <h-input
        label="Last Name"
        v-model="last_name"
        type="text"
        required
      />
      <h-input
        label="Email Address"
        v-model="email"
        type="email"
        required
      />
    </form>
    <div v-for="user in csvUploadedUsers" :key="user.email" class="row">
      <h-input label="First Name" type="text" v-model="user.first_name" />
      <h-input label="Last Name" type="text" v-model="user.last_name" />
      <h-input label="Email" type="email" v-model="user.email" />
      <button :icon="true" @click="remove(user)"><h-icon>delete</h-icon></button>
    </div>
    <client-upload @csvUpload="users => csvUploadedUsers = users"/>
    <client-profile-form :profile="profile" @error="val => clientProfileError = val" />
    <h-select
      v-if="profile.allow_daily_exercises"
      :items="HabitPrograms"
      v-model="habitProgram"
      label="Select Habit Program"
      item-text="name"
      item-value="id"
      single-line
    />
    <h-select
      v-if="profile.allow_self_reflect"
      :items="pulseSurveys"
      v-model="pulseSurvey"
      label="Select Pulse Survey"
      item-text="name"
      item-value="id"
      single-line
    />
    <v-switch
      v-if="profile.allow_courses"
      :label="custom ? 'Specify Courses': 'Default Courses'"
      v-model="custom"
    ></v-switch>
    <div v-if="custom">
      <v-checkbox v-model="assignedCourses" v-for="course in courses" :label="course.title" :value="course.id" :key="course.id"></v-checkbox>
    </div>
    <v-alert type="error" :value="error" >{{error}}</v-alert>
    <v-alert type="success" :value="success" >
      Invitations sent! 
    </v-alert>

    <button v-if="success" class="btn btn--full" @click="$router.push({name: 'clientOnboarding'})">Finish</button>
    <h-btn v-else class="btn btn--full small-top" @click.native="save" :disabled="saving || clientProfileError">Save</h-btn>
    </div>
    </div>
</div>
</template>

<script>
import axios from "axios";
import dataStore from "@/services/api/store";
import clientUpload from "./clientUpload";
import clientProfileForm from '../../components/clients/clientProfileForm'
import Nazgul from "@/services/nazgul";
const STORE_HABIT_PROGRAM = "CoachHabitPrograms";
const STORE_COURSES = "CoachCourses";
const PULSE_SURVEYS = "CoachPulseSurveys";

const USER_END_POINT = `${
  process.env.VUE_APP_API_HOST
}api/coaches/clients/client_upload/`;

export default {
  components: {
    clientUpload,
    clientProfileForm
  },
  data() {
    return {
      habitProgram: undefined,
      first_name: "",
      last_name: "",
      email: "",
      HabitPrograms: [],
      error: "",
      custom: false,
      assignedCourses: [],
      courses: [],
      csvUploadedUsers: [],
      success: false,
      saving: false,
      clientProfileError: false,
      pulseSurveys: [],
      pulseSurvey: undefined,
      profile: {
        home: 'daily_exercises',
        allow_daily_exercises: true,
        allow_self_reflect: true,
        allow_goals: true,
        allow_progress: true,
        allow_courses: true,
        allow_journal: true,
        allow_assessments: true,
        allow_messaging: true
      }
    };
  },
  created() {
    dataStore
      .findAll(STORE_HABIT_PROGRAM, {}, { force: true })
      .then(results => {
        this.HabitPrograms = results;
      });

    dataStore
      .findAll(PULSE_SURVEYS, {}, { force: true })
      .then(results => {
        this.pulseSurveys = results
      })

    dataStore.findAll(STORE_COURSES, {}, { force: true }).then(results => {
      this.courses = results;
    });
  },
  methods: {
    remove(user) {
      this.csvUploadedUsers = this.csvUploadedUsers.filter(u => u !== user);
    },
    save() {
      if (this.profile.allow_daily_exercises && !this.habitProgram) {
        this.error = "Please select an habit program";
        return;
      }
      if (this.profile.allow_self_reflect && !this.pulseSurvey) {
        this.error = "Please select a pulse survey";
        return;
      }
      this.error = "";
      Nazgul.report("new_invitations_created");
      const data = {
        clients: [...this.csvUploadedUsers, {first_name: this.first_name, last_name: this.last_name, email: this.email}],
        habit_program: this.habitProgram,
        courses: this.assignedCourses,
        profile: this.profile
      };

      this.saving = true;
      axios
        .post(USER_END_POINT, data)
        .then(() => {
          this.success = true;
        })
        .catch(({ response }) => {
          if (response.status < 500) {
            this.error = Object.keys(response.data).reduce(
              (message, key) => `${message} ${response.data[key]}`,
              ""
            );
          } else {
            this.error =
              "There was a server error. We have notified our staff. Please try again later.";
          }
        }).finally(() => {
          this.saving = false;
        })
    }
  }
};
</script>
